import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PRIVACY } from "@/constants/testIds";

export default function Privacy() {
  const sections = [
    { h: "Information we collect", p: "When you join our waitlist or place an order, we collect your email address, shipping details, uploaded model files, and order preferences. We also collect basic usage analytics to improve the service." },
    { h: "How we use your information", p: "We use your information to fulfill orders, route prints to the nearest maker hub, provide customer support, send launch and order updates, and improve Printopia. We never sell your personal data." },
    { h: "Your uploaded models", p: "Files you upload remain yours. We use them only to produce your order and to generate print quotes. You can request deletion of your files at any time." },
    { h: "Sharing & disclosure", p: "We share the minimum necessary information with our maker network and shipping partners (including FedEx) to fulfill and deliver your orders. We may disclose information when required by law." },
    { h: "Data retention & security", p: "We retain order records as required for tax and legal purposes and protect your data with industry-standard encryption in transit and at rest." },
    { h: "Your rights", p: "You may access, correct, or delete your personal data, and opt out of marketing emails at any time by contacting privacy@printopia.example." },
    { h: "Contact", p: "Questions about this policy? Email privacy@printopia.example. Printopia currently operates exclusively in the United States." },
  ];

  return (
    <div data-testid={PRIVACY.page} className="min-h-screen bg-background text-foreground">
      <div className="border-b border-border/60 bg-background/80">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo-mark.jpg" alt="Printopia" className="h-9 w-9 rounded-lg object-cover ring-1 ring-[rgba(0,229,255,0.35)]" />
            <span className="font-display text-lg font-semibold tracking-tight">Print<span className="text-neo-cyan">opia</span></span>
          </Link>
          <Link
            data-testid={PRIVACY.backHome}
            to="/"
            className="inline-flex items-center gap-2 rounded-lg border border-border/70 bg-secondary/50 px-3 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <h1 className="font-display text-4xl font-semibold tracking-tight">Privacy Policy</h1>
        <p className="mt-2 font-mono text-xs text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
        <p className="mt-6 text-base leading-relaxed text-muted-foreground">
          Your privacy matters to us. This policy explains what we collect, how
          we use it, and the choices you have when using Printopia.
        </p>

        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl font-semibold text-foreground">{s.h}</h2>
              <p className="mt-2 text-base leading-relaxed text-muted-foreground">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
